import { createFileRoute } from "@tanstack/react-router"
import { Link as LinkRouter } from "@tanstack/react-router"
import { Button, Container, Heading, Link, Text } from "@chakra-ui/react"

export const Route = createFileRoute("/impressum")({
  component: Imprint,
})

function Imprint() {
  return (
      <Container w="80%" mt={20} mb={20}>
        <Button asChild variant="primary" mb={8}><LinkRouter to="/">Zurück</LinkRouter></Button>

        <Heading size="4xl" color="main" mb={8}>Impressum</Heading>
        <Text mb={4}>Herausgeber und verantwortlich für den Inhalt der Internet-Seiten</Text>
        <Text mb={2}>Herrmann AG</Text>
        <Text>Telefon: <Link href="tel:+41 34 409 40 00" color="main">034 409 40 00</Link></Text>
        <Text mb={8}>E-Mail:{" "}<Link href="mailto:info@herrmann-druck.ch" color="main">info@herrmann-druck.ch</Link>
        </Text>

        <Heading size="lg" color="main" mb={2}>Webseite und Webdesign</Heading>
        <Text mb={2}><Link href="https://www.herrmann-druck.ch" color="main" target="_blank">Herrmann AG</Link></Text>
        <Text mb={2}>Brennerstrasse 7</Text>
        <Text mb={8}>3550 Langnau i. E.</Text>

        <Heading size="lg" color="main" mb={2}>Bildquellen</Heading>
        <Text mb={8}>Eigenes Bildarchiv</Text>

        <Heading size="lg" color="main" mb={2}>Disclaimer/Haftungsausschluss</Heading>
        <Text mb={4}>
            Der Herausgeber übernimmt keine Gewährleistung für Aktualität, Korrektheit, Vollständigkeit und Qualität der bereitgestellten Informationen.
            In keinem Fall haftet der Herausgeber für Verluste oder Schäden materieller oder immaterieller Art, die sich aus oder im Zusammenhang mit der Nutzung
            oder Nichtnutzung der angebotenen Informationen beziehungsweise durch die Nutzung fehlerhafter oder unvollständiger Informationen entstehen können.
            Der Herausgeber behält sich ausdrücklich vor, jederzeit Inhalte ohne Ankündigung ganz oder teilweise zu ändern, zu löschen oder zeitweise nicht zu veröffentlichen.
        </Text>
        <Text mb={8}>
            Der Herausgeber hat fremde, das heisst nicht auf Ihren Servern oder in Ihrem Einflussbereich liegende Websites, die mit dieser Website über Verknüpfungen
            (Hyperlinks) allenfalls verbunden sind, nicht überprüft und übernimmt keine Verantwortung für deren Inhalte, die darauf angebotenen Produkte, Dienstleistungen
            oder sonstigen Angebote.
        </Text>

        <Heading size="lg" color="main" mb={2}>Urheberrechte</Heading>
        <Text mb={8}>
            Der gesamte Inhalt und die Struktur der Webseiten ist urheberrechtlich geschützt. Die vollständige oder teilweise Reproduktion, die elektronische oder mit anderen Mitteln
            erfolgte Übermittlung, die Modifikation oder die Benutzung für öffentliche oder kommerzielle Zwecke ist ohne vorherige schriftliche Zustimmung des Herausgebers untersagt.
        </Text>

        <Heading size="lg" color="main" mb={2}>Änderungen</Heading>
        <Text mb={4}>
            Wir können das Impressum jederzeit ohne Vorankündigung anpassen. Es gilt die jeweils aktuelle, auf unserer Website publizierte Fassung.
        </Text>
        <Text>Letzte Änderung 13.11.2025</Text>
      </Container>
    )
}
